const state = {
  userInfo: {}, // 用户信息
  signUpStep: 0, // 登陆步骤
  shoppingCart: [], // 购物车

  token: "", // 登陆token
  QQState: false // 在线QQ
};
const mutations = {
  // 设置用户token
  SET_USER_TOKEN(state, token) {
    state.token = token;
  },
  // 设置用户登录信息
  SET_USER_INFO(state, data) {
    state.userInfo = data;
  },

  // 设置注册步骤
  SET_SIGN_UP_SETP(state, step) {
    state.signUpStep = step;
  },

  // 设置在线客服状态
  SET_QQ_SERVE(state, data) {
    state.QQState = data;
  },

  // 设置购物车信息
  SET_SHOPPING_CART(state, data) {
    state.shoppingCart = data;
  }
};
const actions = {
  // 添加注册用户
  // eslint-disable-next-line no-unused-vars
  ADD_SIGN_UP_USER({ commit }, data) {
    return new Promise(() => {
      const userArr = localStorage.getItem("users");
      let users = [];
      if (userArr) {
        users = JSON.parse(userArr);
      }
      users.push(data);
      localStorage.setItem("users", JSON.stringify(users));
    });
  },

  // 退出登陆
  SIGN_OUT({ commit }) {
    sessionStorage.removeItem("is_login");
    sessionStorage.removeItem("userInfo");
    sessionStorage.removeItem("token");
    commit("SET_USER_INFO", {});
    commit("SET_USER_TOKEN", {});
    commit("SET_SHOPPING_CART", []);
  },

  // 判断是否登陆
  IS_LOGIN({ commit }) {
    return new Promise(resolve => {
      const isLoginState = sessionStorage.getItem("is_login");
      if (isLoginState) {
        const userInfo = sessionStorage.getItem("userInfo");
        commit("SET_USER_INFO", JSON.parse(userInfo));
        const token = sessionStorage.getItem("token");
        commit("SET_USER_TOKEN", token);
        resolve(true);
      } else {
        resolve(false);
      }
    });
  },

  // 设置在线客服状态
  CHANGE_QQ_SERVE({ commit }) {
    commit("SET_QQ_SERVE", false);
  },

  // 更改购物车状态
  CHANGE_SHOPPING_CART({ commit }, data) {
    commit("SET_SHOPPING_CART", data);
  }
};
export default {
  state,
  mutations,
  actions
};
